import { UTCDate } from '@date-fns/utc';
import { addHours } from 'date-fns';
import { getTimezoneOffset } from 'date-fns-tz';

// Normalise a naked Postgres timestamp ("2026-05-25 10:03:00") or ISO string
// into a UTC instant. Mirrors the operations-log diff helper.
export const toUtcDate = (raw: string): UTCDate => {
  let s = (raw.includes('T') ? raw : raw.replace(' ', 'T')).replace(
    /(\.\d{3})\d+/,
    '$1'
  );
  if (!/[Zz]$/.test(s) && !/[+-]\d{2}:?\d{2}$/.test(s)) s = `${s}Z`;
  return new UTCDate(s);
};

const pad = (n: number) => String(n).padStart(2, '0');

// The DateCell office-time badge shows the item's start time in the office
// timezone — but ONLY when it differs from the office (otherwise it's noise).
//  - `time`   → grey badge with the start time in the office timezone
//  - `hidden` → no badge (no start time, no item timezone, or zero offset diff)
export type OfficeTimeBadge =
  | { kind: 'time'; label: string }
  | { kind: 'hidden' };

export const officeTimeBadge = (
  startTime: string | null,
  itemTimezone: string | null,
  userTimezone: string
): OfficeTimeBadge => {
  if (!startTime || !itemTimezone) return { kind: 'hidden' };

  const ref = toUtcDate(startTime);
  const diffHours =
    (getTimezoneOffset(userTimezone, ref) -
      getTimezoneOffset(itemTimezone, ref)) /
    3_600_000;
  if (!Number.isFinite(diffHours) || diffHours === 0) return { kind: 'hidden' };

  const shifted = addHours(ref, diffHours);
  return {
    kind: 'time',
    label: `${pad(shifted.getUTCHours())}:${pad(shifted.getUTCMinutes())}`,
  };
};
